// The Myela identity, as the Dashboard draws it (payments-dashboard components/brand):
// the five-capsule mark for the menu's rail, and the full lockup once the menu opens.

const SIGNAL = "var(--accent-600)";
const CAP_XS = [7, 29, 51, 73, 95];
// The wordmark ends near x=326; the box stops just past it so whatever follows sits beside the word.
const LOCKUP_W = 340;

/** The five Signal capsules. */
export function MyelaMark({ size = 26, title = "Myela" }: { size?: number; title?: string }) {
  return (
    <svg viewBox="0 0 160 100" width={size} height={(size * 100) / 160} fill="#D98E3D" role="img" aria-label={title}>
      {[6, 37, 68, 99, 130].map((x) => (
        <rect key={x} x={x} y="10" width="24" height="80" rx="12" />
      ))}
    </svg>
  );
}

/** Capsules, flow lines and the Orlean wordmark, in currentColor with one Signal accent. */
export function Lockup({ size = 22, className, title = "Myela" }: { size?: number; className?: string; title?: string }) {
  const renderH = (size * 100) / 56;
  return (
    <svg className={className} width={(renderH * LOCKUP_W) / 100} height={renderH} viewBox={`0 0 ${LOCKUP_W} 100`} role="img" aria-label={title}>
      <g transform="translate(10, 22)" fill="currentColor">
        <line x1="0" y1="28" x2="7" y2="28" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
        {CAP_XS.map((x, i) => (
          <rect key={x} x={x} y="0" width="17" height="56" rx="8.5" fill={i === 4 ? SIGNAL : "currentColor"} />
        ))}
        <line x1="112" y1="28" x2="127" y2="28" stroke={SIGNAL} strokeWidth="2.8" strokeLinecap="round" />
      </g>
      <text
        x="170"
        y="70"
        fontFamily="Orlean, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        fontSize="62"
        fontWeight="400"
        letterSpacing="0.5"
        fill="currentColor"
      >
        myela
      </text>
    </svg>
  );
}
